// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { injectCss } from "@insite/mobius/utilities";
import { LazyImage, mapStateToProps, Props } from "@synd/MobiusOverrides/LazyImage";
import breakpoints from "@synd/XDL/PreStyle/breakpoints";
import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";

const LazyPictureStyle = styled.picture<any>`
    max-height: 100%;
    max-width: 100%;
    img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
    }
    ${injectCss}
`;
/**
 * Xng Picture Component
 */
export class LazyPicture extends LazyImage {
    componentDidUpdate(prevProps: Props) {
        if (
            this.props.largeImageSrc !== prevProps.largeImageSrc ||
            this.props.mediumImageSrc !== prevProps.mediumImageSrc ||
            this.props.smallImageSrc !== prevProps.smallImageSrc
        ) {
            this.reloadImage();
        }
    }

    getImgUrl = (src?: string) => {
        const pictureSrc = this.props.disableLazyLoad
            ? this.props.largeImageSrc || this.props.mediumImageSrc || this.props.smallImageSrc
            : "";
        const imgSrc = src || this.props.src || pictureSrc || this.notFound || "";
        return imgSrc;
    };

    renderImage(src?: string, fromPic?: boolean) {
        const { pictureProps, largeImageSrc, mediumImageSrc, smallImageSrc } = this.props as Props;

        return (
            <LazyPictureStyle {...pictureProps}>
                <source
                    media={`(min-width: ${breakpoints.values[3]}px)`}
                    srcSet={this.getImgUrl(largeImageSrc || mediumImageSrc)}
                />
                <source media={`(min-width: ${breakpoints.values[2]}px)`} srcSet={this.getImgUrl(mediumImageSrc)} />
                <source
                    media={`(max-width: ${breakpoints.values[2]}px)`}
                    srcSet={this.getImgUrl(smallImageSrc || mediumImageSrc)}
                />
                {super.renderImage(smallImageSrc)}
            </LazyPictureStyle>
        );
    }
}
/** @component */
export default withTheme(connect(mapStateToProps)(LazyPicture));
